import { useNavigate } from 'react-router';
import { track } from '@gonfalon/analytics/track';
import { toCheckYourEmail } from '@gonfalon/navigator/navigators';
import { getSignupAttributionSearchParams } from '@gonfalon/signup/agentUtmParams';

import { isExistingAccountSignupOutcome, type SignupOutcome } from '#utils/signupOutcome';

type CreateUserSuccess = {
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  organization?: string;
  signupOutcome?: SignupOutcome;
  redirectUrl?: string;
};

export type { CreateUserSuccess };

export function useSignUpHandlers() {
  const navigate = useNavigate();

  const onCreateUnverifiedMemberSuccess = async (account: CreateUserSuccess) => {
    const username = account?.username;

    if (account.redirectUrl) {
      window.location.assign(account.redirectUrl);
      return;
    }

    if (isExistingAccountSignupOutcome(account.signupOutcome) && !!username) {
      await navigate(toCheckYourEmail({ search: getSignupAttributionSearchParams() }), {
        state: { email: username, signupOutcome: account.signupOutcome },
      });
      return;
    }

    track('App Signup Successful', '', {
      email: account.username,
      firstName: account.firstName,
      lastName: account.lastName,
      referrer: window.location.href,
      organization: account.organization,
    });

    if (!!username) {
      await navigate(toCheckYourEmail({ search: getSignupAttributionSearchParams() }), {
        state: { email: username },
      });
    }
  };

  return onCreateUnverifiedMemberSuccess;
}
